export default __webpack_public_path__ + "static/media/bg.4da75391.png";